import Swiper from "swiper";
import {Controller, Navigation, Autoplay, Pagination, EffectFade} from 'swiper/modules';

export default class Show {
    constructor() {
        this.initTaxatie();
        this.uspSlider();
    }

    initTaxatie() {
        new Swiper('#taxatie-table .swiper-container', {
            slidesPerView: 1,
            autoplay: {
                delay: 2500,
            },
            breakpoints: {
                576: {
                    slidesPerView: 3,
                }
            },
        });
    }

    uspSlider() {
        if(document.querySelector('#uspSlider')){
            new Swiper('#uspSlider .swiper-container', {
                slidesPerView: 1,
                spaceBetween: 30,
                autoplay: {
                    delay: 2500,
                },
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                    },
                    992: {
                        slidesPerView: 3,
                    },
                    1200: {
                        slidesPerView: 4,
                    }
                },
            });
        }
    }
}
